import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { ShopSettingsProvider, useShopSettings } from "@/context/ShopSettingsContext";
import Wishlist from "@/pages/Wishlist";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import MyOrders from "@/pages/MyOrders";
import AdminPage from "@/pages/admin/AdminPage";

function usePageTracking(location) {
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const t = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 0);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
}

const SalesRoute = ({ children }) => {
  const { showcase_mode, loaded } = useShopSettings();
  if (!loaded) return null;
  return showcase_mode ? <Navigate to="/" replace /> : children;
};

function AppRouter() {
  const location = useLocation();
  usePageTracking(location);
  const dark = location.pathname === "/";
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className={`flex-1 pb-16 ${dark ? "bg-[#0b0b0f]" : ""}`} data-testid={dark ? "home-dark" : undefined}>
        <Routes>
          <Route path="/" element={<Shop />} />
          <Route path="/prodotto/:id" element={<ProductPage />} />
          <Route path="/carrello" element={<SalesRoute><CartPage /></SalesRoute>} />
          <Route path="/cassa" element={<SalesRoute><ProtectedRoute><CheckoutPage /></ProtectedRoute></SalesRoute>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profilo" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/ordini" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
          <Route path="/preferiti" element={<Wishlist />} />
          <Route path="/admin" element={<ProtectedRoute admin><AdminPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
         <ShopSettingsProvider>
          <CartProvider>
           <WishlistProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
           </WishlistProvider>
          </CartProvider>
         </ShopSettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
